// Philippine Locations Database - Provinces, Cities & Municipalities
// Organized by Region > Province > Cities/Municipalities

const PH_DATA = [
  // NCR - National Capital Region
  { region: "NCR", province: "Metro Manila", locations: [
    "Manila", "Quezon City", "Makati", "Taguig", "Pasig", "Mandaluyong",
    "San Juan", "Marikina", "Pasay", "Parañaque", "Las Piñas", "Muntinlupa",
    "Caloocan", "Malabon", "Navotas", "Valenzuela", "Pateros",
  ]},
  // Region I - Ilocos Region
  { region: "Region I", province: "Ilocos Norte", locations: [
    "Laoag City", "Batac City", "Adams", "Bacarra", "Badoc", "Bangui", "Burgos",
    "Carasi", "Currimao", "Dingras", "Dumalneg", "Marcos", "Nueva Era",
    "Pagudpud", "Paoay", "Pasuquin", "Piddig", "Pinili", "San Nicolas",
    "Sarrat", "Solsona", "Vintar",
  ]},
  { region: "Region I", province: "Ilocos Sur", locations: [
    "Vigan City", "Candon City", "Bantay", "Cabugao", "Caoayan", "Cervantes",
    "Galimuyod", "Gregorio Del Pilar", "Lidlidda", "Magsingal", "Narvacan",
    "San Esteban", "San Ildefonso", "San Vicente", "Santa", "Santa Catalina",
    "Santa Cruz", "Santa Maria", "Santiago", "Santo Domingo", "Sigay",
    "Sinait", "Sugpon", "Suyo", "Tagudin",
  ]},
  { region: "Region I", province: "La Union", locations: [
    "San Fernando City", "Agoo", "Aringay", "Bacnotan", "Bagulin", "Balaoan",
    "Bangar", "Bauang", "Burgos", "Caba", "Luna", "Naguilian", "Pugo",
    "Rosario", "San Gabriel", "San Juan", "Santo Tomas", "Sudipen", "Tubao",
  ]},
  { region: "Region I", province: "Pangasinan", locations: [
    "Dagupan City", "San Carlos City", "Urdaneta City", "Alaminos City",
    "Agno", "Aguilar", "Alcala", "Anda", "Asingan", "Balungao",
    "Bani", "Basista", "Bautista", "Bayambang", "Binalonan", "Binmaley",
    "Bolinao", "Bugallon", "Burgos", "Calasiao", "Dasol", "Infanta",
    "Labrador", "Laoac", "Lingayen", "Mabini", "Malasiqui", "Manaoag",
    "Mangaldan", "Mangatarem", "Mapandan", "Natividad", "Pozorrubio",
    "Rosales", "San Fabian", "San Jacinto", "San Manuel", "San Quintin",
    "Santa Barbara", "Santa Maria", "Sison", "Sual", "Tayug",
    "Umingan", "Urbiztondo", "Villasis",
  ]},
  // Region II - Cagayan Valley
  { region: "Region II", province: "Batanes", locations: [
    "Basco", "Itbayat", "Ivana", "Mahatao", "Sabtang", "Uyugan",
  ]},
  { region: "Region II", province: "Cagayan", locations: [
    "Tuguegarao City", "Aparri", "Alcala", "Allacapan", "Amulung", "Baggao",
    "Ballesteros", "Buguey", "Calayan", "Camalaniugan", "Claveria", "Enrile",
    "Gattaran", "Gonzaga", "Iguig", "Lal-lo", "Lasam", "Pamplona",
    "Peñablanca", "Piat", "Rizal", "Sanchez-Mira", "Santa Ana",
    "Santa Praxedes", "Santa Teresita", "Santo Niño", "Solana", "Tuao",
  ]},
  { region: "Region II", province: "Isabela", locations: [
    "Ilagan City", "Cauayan City", "Santiago City", "Alicia", "Angadanan",
    "Aurora", "Benito Soliven", "Burgos", "Cabagan", "Cabatuan", "Cordon",
    "Delfin Albano", "Dinapigue", "Divilacan", "Echague", "Gamu", "Jones",
    "Luna", "Maconacon", "Mallig", "Naguilian", "Palanan", "Quezon",
    "Quirino", "Ramon", "Reina Mercedes", "Roxas", "San Agustin",
    "San Guillermo", "San Isidro", "San Manuel", "San Mariano",
    "San Mateo", "San Pablo", "Santa Maria", "Tumauini",
  ]},
  { region: "Region II", province: "Nueva Vizcaya", locations: [
    "Bayombong", "Solano", "Ambaguio", "Aritao", "Bagabag", "Bambang",
    "Diadi", "Dupax del Norte", "Dupax del Sur", "Kasibu", "Kayapa",
    "Quezon", "Santa Fe", "Villaverde",
  ]},
  { region: "Region II", province: "Quirino", locations: [
    "Cabarroguis", "Aglipay", "Diffun", "Maddela", "Nagtipunan", "Saguday",
  ]},
  // Region III - Central Luzon
  { region: "Region III", province: "Aurora", locations: [
    "Baler", "Casiguran", "Dilasag", "Dinalungan", "Dingalan", "Dipaculao",
    "Maria Aurora", "San Luis",
  ]},
  { region: "Region III", province: "Bataan", locations: [
    "Balanga City", "Abucay", "Bagac", "Dinalupihan", "Hermosa", "Limay",
    "Mariveles", "Morong", "Orani", "Orion", "Pilar", "Samal",
  ]},
  { region: "Region III", province: "Bulacan", locations: [
    "Malolos City", "Meycauayan City", "San Jose del Monte City", "Angat",
    "Balagtas", "Baliuag", "Bocaue", "Bulakan", "Bustos", "Calumpit",
    "Doña Remedios Trinidad", "Guiguinto", "Hagonoy", "Marilao",
    "Norzagaray", "Obando", "Pandi", "Paombong", "Plaridel", "Pulilan",
    "San Ildefonso", "San Miguel", "San Rafael", "Santa Maria",
  ]},
  { region: "Region III", province: "Nueva Ecija", locations: [
    "Cabanatuan City", "Gapan City", "Palayan City", "San Jose City",
    "Muñoz City", "Aliaga", "Bongabon", "Cabiao", "Carranglan",
    "Cuyapo", "Gabaldon", "General Mamerto Natividad", "General Tinio",
    "Guimba", "Jaen", "Laur", "Licab", "Llanera", "Lupao", "Nampicuan",
    "Pantabangan", "Peñaranda", "Quezon", "Rizal", "San Antonio",
    "San Isidro", "San Leonardo", "Santa Rosa", "Santo Domingo",
    "Talavera", "Talugtug", "Zaragoza",
  ]},
  { region: "Region III", province: "Pampanga", locations: [
    "San Fernando City", "Angeles City", "Mabalacat City", "Apalit", "Arayat",
    "Bacolor", "Candaba", "Floridablanca", "Guagua", "Lubao", "Macabebe",
    "Magalang", "Masantol", "Mexico", "Minalin", "Porac", "San Luis",
    "San Simon", "Santa Ana", "Santa Rita", "Santo Tomas", "Sasmuan",
  ]},
  { region: "Region III", province: "Tarlac", locations: [
    "Tarlac City", "Anao", "Bamban", "Camiling", "Capas", "Concepcion",
    "Gerona", "La Paz", "Mayantoc", "Moncada", "Paniqui", "Pura",
    "Ramos", "San Clemente", "San Jose", "San Manuel", "Santa Ignacia",
    "Victoria",
  ]},
  { region: "Region III", province: "Zambales", locations: [
    "Olongapo City", "Botolan", "Cabangan", "Candelaria", "Castillejos",
    "Iba", "Masinloc", "Palauig", "San Antonio", "San Felipe",
    "San Marcelino", "San Narciso", "Santa Cruz", "Subic",
  ]},
  // Region IV-A - CALABARZON
  { region: "Region IV-A", province: "Batangas", locations: [
    "Batangas City", "Lipa City", "Tanauan City", "Santo Tomas City",
    "Agoncillo", "Alitagtag", "Balayan", "Balete", "Bauan", "Calaca",
    "Calatagan", "Cuenca", "Ibaan", "Laurel", "Lemery", "Lian", "Lobo",
    "Mabini", "Malvar", "Mataas na Kahoy", "Nasugbu", "Padre Garcia",
    "Rosario", "San Jose", "San Juan", "San Luis", "San Nicolas",
    "San Pascual", "Santa Teresita", "Taysan", "Tingloy", "Tuy",
  ]},
  { region: "Region IV-A", province: "Cavite", locations: [
    "Cavite City", "Tagaytay City", "Trece Martires City", "Dasmariñas City",
    "Imus City", "Bacoor City", "General Trias City", "Alfonso", "Amadeo",
    "Carmona", "General Emilio Aguinaldo", "General Mariano Alvarez",
    "Indang", "Kawit", "Magallanes", "Maragondon", "Mendez", "Naic",
    "Noveleta", "Rosario", "Silang", "Tanza", "Ternate",
  ]},
  { region: "Region IV-A", province: "Laguna", locations: [
    "Santa Rosa City", "Calamba City", "San Pedro City", "Biñan City",
    "Cabuyao City", "San Pablo City", "Alaminos", "Bay", "Calauan",
    "Cavinti", "Famy", "Kalayaan", "Liliw", "Los Baños", "Luisiana",
    "Lumban", "Mabitac", "Magdalena", "Majayjay", "Nagcarlan",
    "Paete", "Pagsanjan", "Pakil", "Pangil", "Pila", "Rizal",
    "Santa Cruz", "Santa Maria", "Siniloan", "Victoria",
  ]},
  { region: "Region IV-A", province: "Quezon", locations: [
    "Lucena City", "Tayabas City", "Agdangan", "Alabat", "Atimonan",
    "Buenavista", "Calauag", "Candelaria", "Catanauan", "Dolores",
    "General Luna", "General Nakar", "Guinayangan", "Gumaca", "Infanta",
    "Jomalig", "Lopez", "Lucban", "Macalelon", "Mauban",
    "Mulanay", "Padre Burgos", "Pagbilao", "Panukulan", "Patnanungan",
    "Perez", "Pitogo", "Plaridel", "Polillo", "Quezon", "Real",
    "Sampaloc", "San Andres", "San Antonio", "San Francisco",
    "San Narciso", "Sariaya", "Tagkawayan", "Tiaong", "Unisan",
  ]},
  { region: "Region IV-A", province: "Rizal", locations: [
    "Antipolo City", "Angono", "Baras", "Binangonan", "Cainta", "Cardona",
    "Jalajala", "Morong", "Pililla", "Rodriguez", "San Mateo", "Tanay",
    "Taytay", "Teresa",
  ]},
  // Region IV-B - MIMAROPA
  { region: "Region IV-B", province: "Marinduque", locations: [
    "Boac", "Buenavista", "Gasan", "Mogpog", "Santa Cruz", "Torrijos",
  ]},
  { region: "Region IV-B", province: "Occidental Mindoro", locations: [
    "Mamburao", "Abra de Ilog", "Calintaan", "Looc", "Lubang",
    "Magsaysay", "Paluan", "Rizal", "Sablayan", "San Jose", "Santa Cruz",
  ]},
  { region: "Region IV-B", province: "Oriental Mindoro", locations: [
    "Calapan City", "Baco", "Bansud", "Bongabong", "Bulalacao", "Gloria",
    "Mansalay", "Naujan", "Pinamalayan", "Pola", "Puerto Galera",
    "Roxas", "San Teodoro", "Socorro", "Victoria",
  ]},
  { region: "Region IV-B", province: "Palawan", locations: [
    "Puerto Princesa City", "Aborlan", "Agutaya", "Araceli", "Balabac",
    "Bataraza", "Brooke's Point", "Busuanga", "Cagayancillo", "Coron",
    "Culion", "Cuyo", "Dumaran", "El Nido", "Kalayaan", "Linapacan",
    "Magsaysay", "Narra", "Quezon", "Rizal", "Roxas", "San Vicente",
    "Sofronio Española", "Taytay",
  ]},
  { region: "Region IV-B", province: "Romblon", locations: [
    "Romblon", "Alcantara", "Banton", "Cajidiocan", "Calatrava",
    "Concepcion", "Corcuera", "Ferrol", "Looc", "Magdiwang",
    "Odiongan", "San Agustin", "San Andres", "San Fernando",
    "San Jose", "Santa Fe", "Santa Maria",
  ]},
  // Region V - Bicol Region
  { region: "Region V", province: "Albay", locations: [
    "Legazpi City", "Ligao City", "Tabaco City", "Bacacay", "Camalig",
    "Daraga", "Guinobatan", "Jovellar", "Libon", "Malilipot", "Malinao",
    "Manito", "Oas", "Pio Duran", "Polangui", "Rapu-Rapu",
    "Santo Domingo", "Tiwi",
  ]},
  { region: "Region V", province: "Camarines Norte", locations: [
    "Daet", "Basud", "Capalonga", "Jose Panganiban", "Labo",
    "Mercedes", "Paracale", "San Lorenzo Ruiz", "San Vicente",
    "Santa Elena", "Talisay", "Vinzons",
  ]},
  { region: "Region V", province: "Camarines Sur", locations: [
    "Naga City", "Iriga City", "Baao", "Balatan", "Bato", "Bombon",
    "Buhi", "Bula", "Cabusao", "Calabanga", "Camaligan", "Canaman",
    "Caramoan", "Del Gallego", "Gainza", "Garchitorena", "Goa",
    "Lagonoy", "Libmanan", "Lupi", "Magarao", "Milaor", "Minalabac",
    "Nabua", "Ocampo", "Pamplona", "Pasacao", "Pili", "Presentacion",
    "Ragay", "Sagnay", "San Fernando", "San Jose", "Sipocot",
    "Siruma", "Tigaon", "Tinambac",
  ]},
  { region: "Region V", province: "Catanduanes", locations: [
    "Virac", "Bagamanoc", "Baras", "Bato", "Caramoran", "Gigmoto",
    "Pandan", "Panganiban", "San Andres", "San Miguel", "Viga",
  ]},
  { region: "Region V", province: "Masbate", locations: [
    "Masbate City", "Aroroy", "Baleno", "Balud", "Batuan", "Cataingan",
    "Cawayan", "Claveria", "Dimasalang", "Esperanza", "Mandaon",
    "Milagros", "Mobo", "Monreal", "Palanas", "Pio V. Corpuz",
    "Placer", "San Fernando", "San Jacinto", "San Pascual", "Uson",
  ]},
  { region: "Region V", province: "Sorsogon", locations: [
    "Sorsogon City", "Barcelona", "Bulan", "Bulusan", "Casiguran",
    "Castilla", "Donsol", "Gubat", "Irosin", "Juban", "Magallanes",
    "Matnog", "Pilar", "Prieto Diaz", "Santa Magdalena",
  ]},
  // Region VI - Western Visayas
  { region: "Region VI", province: "Aklan", locations: [
    "Kalibo", "Altavas", "Balete", "Banga", "Batan", "Buruanga",
    "Ibajay", "Lezo", "Libacao", "Madalag", "Makato", "Malay",
    "Malinao", "Nabas", "New Washington", "Numancia", "Tangalan",
  ]},
  { region: "Region VI", province: "Antique", locations: [
    "San Jose de Buenavista", "Anini-y", "Barbaza", "Belison", "Bugasong",
    "Caluya", "Culasi", "Hamtic", "Laua-an", "Libertad", "Pandan",
    "Patnongon", "San Remigio", "Sebaste", "Sibalom", "Tibiao",
    "Tobias Fornier", "Valderrama",
  ]},
  { region: "Region VI", province: "Capiz", locations: [
    "Roxas City", "Cuartero", "Dao", "Dumalag", "Dumarao", "Ivisan",
    "Jamindan", "Ma-ayon", "Mambusao", "Panay", "Panitan", "Pilar",
    "Pontevedra", "President Roxas", "Sapian", "Sigma", "Tapaz",
  ]},
  { region: "Region VI", province: "Guimaras", locations: [
    "Jordan", "Buenavista", "Nueva Valencia", "San Lorenzo", "Sibunag",
  ]},
  { region: "Region VI", province: "Iloilo", locations: [
    "Iloilo City", "Passi City", "Ajuy", "Alimodian", "Anilao", "Badiangan",
    "Balasan", "Banate", "Barotac Nuevo", "Barotac Viejo", "Batad",
    "Bingawan", "Cabatuan", "Calinog", "Carles", "Concepcion",
    "Dingle", "Dueñas", "Dumangas", "Estancia", "Guimbal", "Igbaras",
    "Janiuay", "Lambunao", "Leganes", "Lemery", "Leon", "Maasin",
    "Miagao", "Mina", "New Lucena", "Oton", "Pavia", "Pototan",
    "San Dionisio", "San Enrique", "San Joaquin", "San Miguel",
    "San Rafael", "Santa Barbara", "Sara", "Tigbauan", "Tubungan",
    "Zarraga",
  ]},
  { region: "Region VI", province: "Negros Occidental", locations: [
    "Bacolod City", "Bago City", "Cadiz City", "Escalante City",
    "Himamaylan City", "Kabankalan City", "La Carlota City", "Sagay City",
    "San Carlos City", "Silay City", "Sipalay City", "Talisay City",
    "Victorias City", "Binalbagan", "Calatrava", "Candoni", "Cauayan",
    "Don Salvador Benedicto", "Enrique B. Magalona", "Hinigaran",
    "Hinoba-an", "Ilog", "Isabela", "La Castellana", "Manapla",
    "Moises Padilla", "Murcia", "Pontevedra", "Pulupandan",
    "Salvador Benedicto", "San Enrique", "Toboso", "Valladolid",
  ]},
  // Region VII - Central Visayas
  { region: "Region VII", province: "Bohol", locations: [
    "Tagbilaran City", "Alburquerque", "Alicia", "Anda", "Antequera",
    "Baclayon", "Balilihan", "Batuan", "Bien Unido", "Bilar",
    "Calape", "Candijay", "Carmen", "Catigbian", "Clarin", "Corella",
    "Cortes", "Dagohoy", "Danao", "Dauis", "Dimiao", "Duero",
    "Garcia Hernandez", "Getafe", "Guindulman", "Inabanga", "Jagna",
    "Lila", "Loay", "Loboc", "Loon", "Mabini", "Maribojoc",
    "Panglao", "Pilar", "Pres. Carlos P. Garcia", "Sagbayan",
    "San Isidro", "San Miguel", "Sevilla", "Sierra Bullones",
    "Sikatuna", "Talibon", "Trinidad", "Tubigon", "Ubay", "Valencia",
  ]},
  { region: "Region VII", province: "Cebu", locations: [
    "Cebu City", "Mandaue City", "Lapu-Lapu City", "Danao City",
    "Toledo City", "Talisay City", "Naga City", "Carcar City",
    "Bogo City", "Alcantara", "Alcoy", "Alegria", "Aloguinsan",
    "Argao", "Asturias", "Badian", "Balamban", "Bantayan", "Barili",
    "Boljoon", "Borbon", "Carmen", "Catmon", "Compostela",
    "Consolacion", "Cordova", "Daanbantayan", "Dalaguete", "Dumanjug",
    "Ginatilan", "Liloan", "Madridejos", "Malabuyoc", "Medellin",
    "Minglanilla", "Moalboal", "Oslob", "Pilar", "Pinamungajan",
    "Poro", "Ronda", "Samboan", "San Fernando", "San Francisco",
    "San Remigio", "Santa Fe", "Santander", "Sibonga", "Sogod",
    "Tabogon", "Tabuelan", "Tuburan", "Tudela",
  ]},
  { region: "Region VII", province: "Negros Oriental", locations: [
    "Dumaguete City", "Bayawan City", "Bais City", "Canlaon City",
    "Guihulngan City", "Tanjay City", "Amlan", "Ayungon", "Bacong",
    "Basay", "Bindoy", "Dauin", "Jimalalud", "La Libertad",
    "Mabinay", "Manjuyod", "Pamplona", "San Jose", "Santa Catalina",
    "Siaton", "Sibulan", "Tayasan", "Valencia", "Vallehermoso", "Zamboanguita",
  ]},
  { region: "Region VII", province: "Siquijor", locations: [
    "Siquijor", "Enrique Villanueva", "Larena", "Lazi", "Maria", "San Juan",
  ]},
  // Region VIII - Eastern Visayas
  { region: "Region VIII", province: "Leyte", locations: [
    "Tacloban City", "Ormoc City", "Baybay City", "Abuyog", "Alangalang",
    "Babatngon", "Bato", "Burauen", "Calubian", "Capoocan", "Dagami",
    "Dulag", "Hilongos", "Hindang", "Inopacan", "Isabel", "Jaro",
    "Julita", "Kananga", "La Paz", "Leyte", "MacArthur", "Mahaplag",
    "Matag-ob", "Mayorga", "Merida", "Palo", "Palompon", "Pastrana",
    "San Isidro", "San Miguel", "Santa Fe", "Tabango", "Tabontabon",
    "Tanauan", "Tolosa", "Tunga", "Villaba",
  ]},
  { region: "Region VIII", province: "Samar", locations: [
    "Catbalogan City", "Calbayog City", "Basey", "Calbiga", "Daram",
    "Gandara", "Hinabangan", "Jiabong", "Marabut", "Motiong",
    "Paranas", "San Jorge", "San Jose de Buan", "San Sebastian",
    "Santa Margarita", "Santa Rita", "Tarangnan", "Villareal", "Zumarraga",
  ]},
  { region: "Region VIII", province: "Southern Leyte", locations: [
    "Maasin City", "Bontoc", "Hinunangan", "Hinundayan", "Libagon",
    "Liloan", "Limasawa", "Macrohon", "Malitbog", "Padre Burgos",
    "Pintuyan", "Saint Bernard", "San Francisco", "San Juan",
    "San Ricardo", "Silago", "Sogod", "Tomas Oppus",
  ]},
  { region: "Region VIII", province: "Eastern Samar", locations: [
    "Borongan City", "Arteche", "Balangiga", "Balangkayan", "Can-avid",
    "Dolores", "General MacArthur", "Giporlos", "Guiuan", "Hernani",
    "Jipapad", "Lawaan", "Llorente", "Maslog", "Maydolong", "Mercedes",
    "Oras", "Quinapondan", "Salcedo", "San Julian", "San Policarpo",
    "Sulat", "Taft",
  ]},
  // Region IX - Zamboanga Peninsula
  { region: "Region IX", province: "Zamboanga del Norte", locations: [
    "Dipolog City", "Dapitan City", "Bacungan", "Baliguian", "Godod",
    "Gutalac", "Jose Dalman", "Kalawit", "Katipunan", "La Libertad",
    "Labason", "Leon B. Postigo", "Liloy", "Manukan", "Mutia",
    "Piñan", "Polanco", "Rizal", "Roxas", "Salug", "Sergio Osmeña Sr.",
    "Siayan", "Sibuco", "Sibutad", "Sindangan", "Siocon", "Sirawai",
    "Tampilisan",
  ]},
  { region: "Region IX", province: "Zamboanga del Sur", locations: [
    "Pagadian City", "Zamboanga City", "Aurora", "Bayog", "Dimataling",
    "Dinas", "Dumalinao", "Dumingag", "Guipos", "Josefina", "Kumalarang",
    "Labangan", "Lakewood", "Lapuyan", "Mahayag", "Margosatubig",
    "Midsalip", "Molave", "Pitogo", "Ramon Magsaysay", "San Miguel",
    "San Pablo", "Sominot", "Tabina", "Tambulig", "Tigbao",
    "Tukuran", "Vincenzo A. Sagun",
  ]},
  { region: "Region IX", province: "Zamboanga Sibugay", locations: [
    "Ipil", "Alicia", "Buug", "Diplahan", "Imelda", "Kabasalan",
    "Mabuhay", "Malangas", "Naga", "Olutanga", "Payao",
    "Roseller Lim", "Siay", "Talusan", "Titay", "Tungawan",
  ]},
  // Region X - Northern Mindanao
  { region: "Region X", province: "Bukidnon", locations: [
    "Malaybalay City", "Valencia City", "Baungon", "Cabanglasan",
    "Damulog", "Dangcagan", "Don Carlos", "Impasugong", "Kadingilan",
    "Kalilangan", "Kibawe", "Kitaotao", "Lantapan", "Libona",
    "Malitbog", "Manolo Fortich", "Maramag", "Pangantucan",
    "Quezon", "San Fernando", "Sumilao", "Talakag",
  ]},
  { region: "Region X", province: "Camiguin", locations: [
    "Mambajao", "Catarman", "Guinsiliban", "Mahinog", "Sagay",
  ]},
  { region: "Region X", province: "Lanao del Norte", locations: [
    "Iligan City", "Bacolod", "Baloi", "Baroy", "Kapatagan",
    "Kauswagan", "Kolambugan", "Lala", "Linamon", "Magsaysay",
    "Maigo", "Matungao", "Munai", "Nunungan", "Pantao Ragat",
    "Pantar", "Poona Piagapo", "Salvador", "Sapad", "Sultan Naga Dimaporo",
    "Tagoloan", "Tangcal", "Tubod",
  ]},
  { region: "Region X", province: "Misamis Occidental", locations: [
    "Oroquieta City", "Ozamiz City", "Tangub City", "Aloran", "Baliangao",
    "Bonifacio", "Calamba", "Clarin", "Concepcion", "Don Victoriano Chiongbian",
    "Jimenez", "Lopez Jaena", "Panaon", "Plaridel", "Sapang Dalaga",
    "Sinacaban", "Tudela",
  ]},
  { region: "Region X", province: "Misamis Oriental", locations: [
    "Cagayan de Oro City", "Gingoog City", "El Salvador City", "Alubijid",
    "Balingasag", "Balingoan", "Binuangan", "Claveria", "Gitagum",
    "Initao", "Jasaan", "Kinoguitan", "Lagonglong", "Laguindingan",
    "Libertad", "Lugait", "Magsaysay", "Manticao", "Medina",
    "Naawan", "Opol", "Salay", "Sugbongcogon", "Tagoloan",
    "Talisayan", "Villanueva",
  ]},
  // Region XI - Davao Region
  { region: "Region XI", province: "Davao de Oro", locations: [
    "Nabunturan", "Compostela", "Laak", "Mabini", "Maco", "Maragusan",
    "Mawab", "Monkayo", "Montevista", "New Bataan", "Pantukan",
  ]},
  { region: "Region XI", province: "Davao del Norte", locations: [
    "Tagum City", "Panabo City", "Samal City", "Asuncion", "Braulio E. Dujali",
    "Carmen", "Kapalong", "New Corella", "San Isidro", "Santo Tomas", "Talaingod",
  ]},
  { region: "Region XI", province: "Davao del Sur", locations: [
    "Davao City", "Digos City", "Bansalan", "Don Marcelino", "Hagonoy",
    "José Abad Santos", "Kiblawan", "Magsaysay", "Malalag", "Malita",
    "Matanao", "Padada", "Santa Cruz", "Santa Maria", "Sarangani",
    "Sulop",
  ]},
  { region: "Region XI", province: "Davao Oriental", locations: [
    "Mati City", "Baganga", "Banaybanay", "Boston", "Caraga", "Cateel",
    "Governor Generoso", "Lupon", "Manay", "San Isidro", "Tarragona",
  ]},
  // Region XII - SOCCSKSARGEN
  { region: "Region XII", province: "Cotabato", locations: [
    "Kidapawan City", "Alamada", "Aleosan", "Antipas", "Arakan",
    "Banisilan", "Carmen", "Kabacan", "Libungan", "M'lang",
    "Magpet", "Makilala", "Matalam", "Midsayap", "Pigcawayan",
    "Pikit", "President Roxas", "Tulunan",
  ]},
  { region: "Region XII", province: "Sarangani", locations: [
    "Alabel", "Glan", "Kiamba", "Maasim", "Maitum", "Malapatan", "Malungon",
  ]},
  { region: "Region XII", province: "South Cotabato", locations: [
    "Koronadal City", "General Santos City", "Banga", "Lake Sebu",
    "Norala", "Polomolok", "Santo Niño", "Surallah", "T'boli",
    "Tampakan", "Tantangan", "Tupi",
  ]},
  { region: "Region XII", province: "Sultan Kudarat", locations: [
    "Tacurong City", "Bagumbayan", "Columbio", "Esperanza", "Isulan",
    "Kalamansig", "Lambayong", "Lebak", "Lutayan", "Palimbang",
    "President Quirino", "Senator Ninoy Aquino",
  ]},
  // Region XIII - Caraga
  { region: "Region XIII", province: "Agusan del Norte", locations: [
    "Butuan City", "Cabadbaran City", "Buenavista", "Carmen", "Jabonga",
    "Kitcharao", "Las Nieves", "Magallanes", "Nasipit", "Remedios T. Romualdez",
    "Santiago", "Tubay",
  ]},
  { region: "Region XIII", province: "Agusan del Sur", locations: [
    "Bayugan City", "Bunawan", "Esperanza", "La Paz", "Loreto",
    "Prosperidad", "Rosario", "San Francisco", "San Luis",
    "Santa Josefa", "Sibagat", "Talacogon", "Trento", "Veruela",
  ]},
  { region: "Region XIII", province: "Dinagat Islands", locations: [
    "San Jose", "Basilisa", "Cagdianao", "Dinagat", "Libjo", "Loreto", "Tubajon",
  ]},
  { region: "Region XIII", province: "Surigao del Norte", locations: [
    "Surigao City", "Alegria", "Bacuag", "Burgos", "Claver", "Dapa",
    "Del Carmen", "General Luna", "Gigaquit", "Mainit", "Malimono",
    "Pilar", "Placer", "San Benito", "San Francisco", "San Isidro",
    "Santa Monica", "Sison", "Socorro", "Tagana-an", "Tubod",
  ]},
  { region: "Region XIII", province: "Surigao del Sur", locations: [
    "Tandag City", "Bislig City", "Barobo", "Bayabas", "Cagwait",
    "Cantilan", "Carmen", "Carrascal", "Cortes", "Hinatuan",
    "Lanuza", "Lianga", "Lingig", "Madrid", "Marihatag", "San Agustin",
    "San Miguel", "Tagbina", "Tago",
  ]},
  // CAR - Cordillera Administrative Region
  { region: "CAR", province: "Abra", locations: [
    "Bangued", "Boliney", "Bucay", "Bucloc", "Daguioman", "Danglas",
    "Dolores", "La Paz", "Lacub", "Lagangilang", "Lagayan", "Langiden",
    "Licuan-Baay", "Luba", "Malibcong", "Manabo", "Peñarrubia",
    "Pidigan", "Pilar", "Sallapadan", "San Isidro", "San Juan",
    "San Quintin", "Tayum", "Tineg", "Tubo", "Villaviciosa",
  ]},
  { region: "CAR", province: "Apayao", locations: [
    "Kabugao", "Calanasan", "Conner", "Flora", "Luna", "Pudtol", "Santa Marcela",
  ]},
  { region: "CAR", province: "Benguet", locations: [
    "Baguio City", "La Trinidad", "Atok", "Bakun", "Bokod", "Buguias",
    "Itogon", "Kabayan", "Kapangan", "Kibungan", "Mankayan", "Sablan",
    "Tuba", "Tublay",
  ]},
  { region: "CAR", province: "Ifugao", locations: [
    "Lagawe", "Aguinaldo", "Alfonso Lista", "Asipulo", "Banaue",
    "Hingyon", "Hungduan", "Kiangan", "Lamut", "Mayoyao", "Tinoc",
  ]},
  { region: "CAR", province: "Kalinga", locations: [
    "Tabuk City", "Balbalan", "Lubuagan", "Pasil", "Pinukpuk",
    "Rizal", "Tanudan", "Tinglayan",
  ]},
  { region: "CAR", province: "Mountain Province", locations: [
    "Bontoc", "Barlig", "Bauko", "Besao", "Natonin", "Paracelis",
    "Sabangan", "Sadanga", "Sagada", "Tadian",
  ]},
  // BARMM
  { region: "BARMM", province: "Basilan", locations: [
    "Lamitan City", "Isabela City", "Akbar", "Al-Barka", "Hadji Mohammad Ajul",
    "Hadji Muhtamad", "Lantawan", "Maluso", "Sumisip", "Tabuan-Lasa",
    "Tipo-Tipo", "Tuburan", "Ungkaya Pukan",
  ]},
  { region: "BARMM", province: "Lanao del Sur", locations: [
    "Marawi City", "Bacolod-Kalawi", "Balabagan", "Balindong", "Bayang",
    "Binidayan", "Buadiposo-Buntong", "Bubong", "Butig", "Calanogas",
    "Ditsaan-Ramain", "Ganassi", "Kapai", "Kapatagan", "Lumba-Bayabao",
    "Lumbatan", "Lumbayanague", "Madalum", "Madamba", "Maguing",
    "Malabang", "Marantao", "Marogong", "Masiu", "Mulondo",
    "Pagayawan", "Piagapo", "Picong", "Poona Bayabao", "Pualas",
    "Saguiaran", "Sultan Dumalondong", "Tagoloan II", "Tamparan",
    "Taraka", "Tubaran", "Tugaya", "Wao",
  ]},
  { region: "BARMM", province: "Maguindanao del Norte", locations: [
    "Cotabato City", "Datu Odin Sinsuat", "Kabuntalan", "Northern Kabuntalan",
    "Sultan Kudarat", "Sultan Mastura", "Upi",
  ]},
  { region: "BARMM", province: "Maguindanao del Sur", locations: [
    "Buluan", "Datu Paglas", "Datu Piang", "Datu Saudi-Ampatuan",
    "General S.K. Pendatun", "Guindulungan", "Mamasapano",
    "Mangudadatu", "Pagalungan", "Paglat", "Pandag", "Rajah Buayan",
    "Shariff Aguak", "Shariff Saydona Mustapha", "South Upi",
    "Sultan sa Barongis", "Talayan", "Talitay",
  ]},
  { region: "BARMM", province: "Sulu", locations: [
    "Jolo", "Hadji Panglima Tahil", "Indanan", "Kalingalan Caluang",
    "Luuk", "Maimbung", "Old Panamao", "Omar", "Pandami", "Panglima Estino",
    "Pangutaran", "Parang", "Pata", "Patikul", "Siasi", "Talipao",
    "Tapul", "Tongkil",
  ]},
  { region: "BARMM", province: "Tawi-Tawi", locations: [
    "Bongao", "Languyan", "Mapun", "Panglima Sugala", "Sapa-Sapa",
    "Sibutu", "Simunul", "Sitangkai", "South Ubian", "Tandubas",
    "Turtle Islands",
  ]},
];

// Build flat searchable list: "Location, Province"
const ALL_LOCATIONS = [];
PH_DATA.forEach(p => {
  p.locations.forEach(loc => {
    ALL_LOCATIONS.push({
      value: `${loc}, ${p.province}`,
      label: `${loc}, ${p.province}`,
      location: loc,
      province: p.province,
      region: p.region,
    });
  });
});

// Sort alphabetically by location name
ALL_LOCATIONS.sort((a, b) => a.location.localeCompare(b.location));

export { PH_DATA, ALL_LOCATIONS };

// Get unique provinces
export function getProvinces() {
  return PH_DATA.map(p => p.province);
}

// Search locations (returns top N matches)
export function searchLocations(query, limit = 20) {
  if (!query || query.length < 1) return ALL_LOCATIONS.slice(0, limit);
  const q = query.toLowerCase();
  return ALL_LOCATIONS
    .filter(l => l.location.toLowerCase().includes(q) || l.province.toLowerCase().includes(q) || l.region.toLowerCase().includes(q))
    .slice(0, limit);
}
